import React, { useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  FormInput,
  Row,
  Col,
  FormFeedback,
} from "shards-react";
import { useFormik } from "formik";
import baseUrl from "config/baseUrl";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";

const axios = require("axios").default;
const FormConfirmeMail = (props) => {
  const { onChangeStatus, onCancel, statusPass } = props;
  const { t, i18n } = useTranslation();

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = t("common:logIn.PleaseEnterEmail");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validate,
    onSubmit: (values, { setErrors, resetForm }) => {
      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/send-forgot-pass`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      };
      axios(config)
        .then((response) => {
          showNotify(t("common:logIn.WarnEmail"));
          onCancel();
        })
        .catch((error) => {
          setErrors({ email: "Invalid email address" });
          showNotify("Invalid email address", "error");
        });
    },
  });
  return (
    <>
      <ToastContainer />
      <h6 className="bold text-center">
        {statusPass === "changePass" ? t("common:logIn.ChangeNewPassword") : t("common:logIn.ForgotPassword")}
      </h6>
      <h6 className="bold">{t("common:logIn.VerifyEmail")}</h6>
      <p>{t("common:logIn.EnterEmail")}</p>
      <Form onSubmit={formik.handleSubmit}>
        <FormGroup className="mb-5">
          <label htmlFor="#username">
          {t("common:logIn.Email")}<span className="color-red">*</span>
          </label>
          <FormInput
            type="email"
            name="email"
            placeholder={t("common:logIn.Email")}
            onChange={formik.handleChange}
            invalid={!!formik.errors.email}
            value={formik.values.email}
          />
          {formik.errors.email && (
            <FormFeedback>{t("common:logIn.PleaseEnterEmail")}</FormFeedback>
          )}
        </FormGroup>
        <hr />
        <Row>
          {statusPass === "changePass" ? (
            <Col md="12">
              <Button className="btn btn-success w-100 mb-3" type="submit">
              {t("common:logIn.VerifyEmail")}
              </Button>
            </Col>
          ) : (
            <>
              <Col md="6">
                <Button
                  className="btn btn-white w-100 mb-3"
                  onClick={() => onChangeStatus(1)}
                >
                  {`< ${t("common:logIn.Back")}`}
                </Button>
              </Col>
              <Col md="6">
                <Button className="btn btn-success w-100 mb-3" type="submit">
                {t("common:logIn.VerifyEmail")}
                </Button>
              </Col>
            </>
          )}
        </Row>
      </Form>
    </>
  );
};

export default FormConfirmeMail;
